/**
 * @ngdoc constants
 */

/**
 * Translation constant
 */
module.constant('translation', {
    fr: {
        home: 'Accueil',
        loading: 'Chargement en cours',
        loadingcart: 'Nous traitons votre demande, cela peut prendre quelques secondes, merci de patienter.',
        server: {
            notResponding: 'Une erreur est survenue. Veuillez réessayer ultérieurement.',
            notRespondingCheckEmail: 'Une erreur est survenue. Veuillez réessayer ultérieurement en vérifiant votre adresse e-mail.'
        },
        gallery: {
            seePictures: 'Voir les {number} photos',
            seeAll: 'Voir toutes les photos',
            close: 'Fermer le diaporama'
        },
        news: {
            goBack: 'Retour à la liste des actualités',
            discover: "Découvrir toute l'actu",
            title: 'Actualités',
            more: 'En savoir plus',
            empty: 'Aucun actualité',
            moreNews: 'Afficher les {number} actualités suivantes',
            all: 'Toutes les actus'
        },
        common: {
            dateFormat: 'jj/mm/aaaa',
            choiceDate: 'Choisir',
            knowMore: 'En savoir plus',
            backTop: 'Haut de page',
            account: 'Mon espace',
            cart: 'Mon panier',
            cartLegend: 'Afficher mon panier',
            information: 'Information',
            closeMenu: 'Fermer le menu',
            backHome: "Retour à l'accueil",
            share: 'Partager',
            print: 'Imprimer',
            delete: 'Supprimer',
            aDay: 'Le',
            aDate: 'le',
            from: 'Du',
            to: 'au',
            toDay: 'à',
            at: 'à',
            readMore: 'Lire la suite',
            ok: 'Ok',
            phone: 'Téléphone',
            day: 'jour',
            days: 'jours',
            lastUpdate: 'dernière mise à jour',
            unauthorizedAccess: 'Accès non autorisé',
            levelValidated: "Niveaux validés par les Glénans"
        },
        catalog: {
            title: 'Demande de catalogue',
            titleShort: 'Nos catalogues',
            success: 'Votre demande a bien été enregistrée.'
        },
        newsletter: {
            title: 'Newsletter',
            register_ok: 'Votre inscription a bien été enregistrée.',
            newsletter_glenans: 'J’accepte de recevoir des newsletter, des informations et des offres commerciales concernant Les Glénans',
            newsletter_partners: 'J’accepte de recevoir des newsletter, des informations de la part des partenaires officiels et institutionnels des Glénans'
        },
        footer: {
            needHelp: "Besoin d'aide ?",
            faq: 'Foire aux questions',
            chat: 'Échanger par chat',
            chatContact: 'Contacter un conseiller',
            emails: 'Nous contacter',
            newsletter: 'Restez connecté',
            newsletterDescription: 'Inscrivez-vous à notre newsletter',
            newsletterPlaceholder: 'Adresse e-mail',
            seeMoreCatalog: 'Voir nos catalogues'
        },
        internship: {
            moreCriterias: '+ de critères',
            accessResults: 'Retour en haut de page',
            accessFilters: 'Filtrer les résultats',
            criteriaSearch: 'Votre recherche',
            modifyDate: 'Modifier la date',
            lastMinuteOffers: {
                first: 'Offres',
                last: 'dernière minute'
            },
            regionLabel: 'Je souhaite aller',
            activityLabel: 'Je souhaite faire',
            allOffers: 'Voir toutes les offres',
            traineeOffers: 'Voir les offres stagiaires',
            audienceLabel: 'Pour qui ?',
            query: 'Quelle activité aimeriez-vous pratiquer, dans quelle région ?',
            queryShort: 'Quelle activité, quelle région ?',
            noResult: 'Aucun stage ne correspond à vos critères de recherche',
            showMore: 'Afficher les {number} résultats suivants',
            sortDiscountPrice: 'Prix du moins cher au plus cher',
            sortDiscount: 'Offre coup de vent en 1er',
            sortDuo: 'Offre duo en 1er',
            sortBase: 'Base',
            sortUniverse: 'Univers',
            sortActivity: 'Filière',
            duo: 'Offre duo malin',
            duoDescription: "Réservez un 2ème stage d'au moins une semaine et bénéficier d'une réduction de 42 à 110€.",
            membership: 'L’adhésion à l’association est obligatoire pour toute souscription ou commande : 34 euros',
            title: 'Nos stages',
            titleLong: 'Nos offres de stages',
            titleInstructor: 'Stages à encadrer',
            activity: 'Activité',
            universe: 'Univers',
            region: 'Région',
            beginDate: 'Date de début',
            endDate: 'Date de fin',
            budget: 'Budget',
            person: 'personne',
            persons: 'personnes',
            personsAndMore: 'personnes et plus',
            privatize: 'Privatisation',
            navigation: 'Navigation',
            nourriture_partiellement_comprise: 'Nourriture partiellement comprise (comprise sur site)',
            nourriture_non_comprise : 'Nourriture non comprise',
            nourriture_comprise: 'Nourriture comprise',
            audience: 'Public',
            level: 'Niveau',
            accommodation: 'Hébergement',
            duration: 'Durée',
            accommodationSeeMore: 'En savoir plus sur l\'hébergement',
            plan: 'Le programme',
            goals: 'Objectifs',
            learning: 'Apprentissage',
            proceeding: 'Déroulé',
            selectLocation: 'Sélectionnez la base',
            sites: 'sites',
            selectDate: 'Sélectionnez date et durée',
            departure: 'Dép.',
            return: 'Ret.',
            shipShort: 'bat',
            personShort: 'pers',
            participants: 'Participants',
            numberParticipants: 'Nombre de participants',
            personSingular: 'Personne',
            personPlural: 'Personnes',
            privatizeShip: 'Privatisation du bateau',
            shipPriceDetail: 'Détail prix bateau',
            privatizable: 'Le bateau est privatisable à partir de 3 personnes minimum',
            totalPrice: 'Montant total',
            book: 'Je réserve',
            fleet: 'Flotte',
            place: 'Contact de la base',
            address: 'Adresse',
            contact: 'Contact',
            phone: 'Téléphone',
            schedule: 'Horaires',
            link: 'Voir le résumé',
            from: 'à partir de',
            lastminute: 'Offre de dernière minute',
            formerprice: 'au lieu de',
            new: 'Nouveauté',
            goto: 'Accéder au stage',
            stockLow: 'Dernières places',
            stockEmpty: 'Complet',
            moreInfo: 'Détail',
            moreDates: 'Voir les autres dates',
            moreInfoSubscription: 'Détail / inscription'
        },
        calendar: {
            fromDate: 'Du',
            toDate: 'au',
            day: 'jour',
            days: 'jours',
            return: 'Ret. le',
            availablePlace: 'place disp.',
            availablePlaces: 'places disp.',
            full: 'Complet',
            personShort: 'pers',
            noDate: 'Aucune date disponible.'
        },
        order: {
            bookingCondition: 'Vous devez accepter les conditions générales d\'utilisation',
            bail: 'Caution',
            summary: 'Récapitulatif de ma commande',
            summaryDescription: 'article(s) & option(s)',
            identification: 'Identification',
            participants: 'Participants',
            payment: 'Paiement',
            confirmation: 'Confirmation',
            delivery: 'Livraison',
            deliveryDescription: 'Merci de vérifier votre adresse de livraison',
            updateDeliveryInfo: 'Valider mon addresse de livraison',
            payTitle: 'Je règle ma commande',
            card: 'Carte bancaire',
            transfer: 'Virement',
            check: 'Chèque (y compris chèque cadeau et vacances)',
            bookingOption: 'Je pose une option',
            bookingOptionDescription: 'Place(s) garantie(s) pendant 7 jours ouvrés',
            payAll: 'Je règle le total',
            payAdvance: 'Je règle un acompte',
            couponLabel: 'Code réduction ?',
            couponPlaceholder: 'Saisissez votre code ici',
            couponButton: 'Ok',
            unknownOrder: 'La commande recherchée est inconnue.',
            confirmationThanks: 'Merci {name},',
            confirmationThanksDescription: 'votre commande a bien été prise en compte',
            billAddress: 'Adresse de facturation',
            deliveryAddress: 'Adresse de livraison',
            deliveryEstimated: 'Livraison estimée le',
            phone: 'Tél.',
            advancePayment: 'Vous pouvez choisir entre régler la totalité de votre commande dès à présent ou régler un acompte. Dans ce cas, le solde sera à régler au plus tard à 30 jours du début des stages.'
        },
        shop: {
            essentials: 'Les indispensables',
            title: 'Produits boutique',
            titlePage: 'Boutique Les Glénans',
            titleShort: 'Boutique',
            back: 'Retour à la liste',
            addToCart: 'Ajouter au panier',
            from: 'à partir de',
            discover: 'Découvrir la boutique',
            discoverAll: 'Découvrir toute la boutique',
            discoverGlenans: 'Découvrir toute la boutique des Glénans',
            categories: 'Éditions, Outils pédagogiques, Textile et accessoires',
            order: 'Je commande',
            delivery: 'Livraison',
            deliveryCharge: 'Frais de livraison',
            deliveryChargeFrom: 'Frais de livraison à domicile : à partir de',
            deliveryDate: {
                start: 'Expédié sous',
                end: 'jours',
                days : 'Livraison prévue pour le'
            },
            technical: 'Informations techniques',
            description: 'Description',
            soldOut: 'Épuisé',
            limited: 'Stock limité',
            stock: 'En stock',
            conditions: "Les produits de la boutique ne peuvent être vendus qu'aux adhérents des Glénans (excepté pour les \"bons cadeaux Glénans\")",
            priceMembership: 'prix adhérent',
            upsellInternshipsTitle: 'Mettez en application vos connaissances',
            upsellInternshipsButton: 'Découvrir toutes les offres',
            upsellProductTitle: 'Fréquemment achetés ensemble',
            pictureNumber: 'image produit n°',
            showPreviousPicture: "Voir l'image précédente",
            showNextPicture: "Voir l'image suivant",
            previousProduct: 'Produit précédent',
            nextProduct: 'Produit suivant'
        },
        cart: {
            upsellTitle: 'Vous pourriez aussi aimer...',
            title: 'Mon panier',
            membershipLabel: 'Cotisation annuelle 2017 à l’association les Glénans',
            memberNumber: "Numéro d'adhérent",
            memberPlaceholder: 'numéro à 7 chiffres',
            notMember: "Si vous n'avez pas de numéro d'adhérent ou si vous ne le connaissez pas, merci de remplir les champs ci-dessous.",
            summary: 'Récapitulatif',
            emptyInternship: 'Aucun stage dans votre panier.',
            emptyProduct: 'Aucun produit dans votre panier.',
            participants: 'Participants',
            quantity: 'Quantité',
            details: 'Voir la fiche',
            prepare: 'Préparez votre stage',
            add: 'Ajouter au panier',
            options: 'articles & options',
            hideSummary: 'Masquer le détail',
            free: 'Gratuit',
            alreadyExist: 'Cet article est déjà présent dans votre panier, voulez-vous le remplacer ?',
            coupon: 'Code de réduction'
        },
        participants: {
            participant: 'Participant',
            title: 'Identité des participants',
            participantAuth: 'Je suis le participant',
            legalGuardianAuth: 'Je suis le tuteur légal',
            civility: 'Civilité',
            lastname: 'Nom',
            firstname: 'Prénom',
            birthday: 'Date de naissance',
            mail: 'E-mail',
            phone: 'Téléphone portable',
            legalGuardianTitle: 'Coordonnées du tuteur légal',
            otherContactTitle: "Autre personne à contacter en cas d'urgence",
            defineOtherContact: "Renseigner un autre contact",
            options: 'Options & équipements',
            optionsExamples: 'passeport voile, location de matériels, …',
            downloadInsurance: 'Télécharger les conditions d\'assurances',
            submit: 'Je règle la commande',
            categories: 'Éditions, Outils pédagogiques, Textile et accessoires',
            completeFile: 'Dossier complet',
            attendance: 'Présence',
            age: 'Âge',
            adult: 'Majeur'
        },
        form: {
            refresh: 'Actualiser',
            showDetails: 'Afficher le détail',
            hideDetails: 'Masquer le détail',
            choiceCatalog: 'Je souhaite',
            choiceCatalogDownload: 'télécharger le(s) catalogue(s)',
            choiceCatalogMail: 'recevoir le(s) catalogue(s) par courrier',
            choiceCatalgType: 'Je choisis le(s) catalogue(s)',
            catalog_adulte: 'catalogue adulte',
            catalog_junior: 'catalogue junior',
            export: 'exporter',
            requiredCatalog: 'Vous devez choisir au moins un catalogue',
            loginPassUnknown: 'Utilisateur et/ou mot de passe inconnu(s)',
            openclose: 'Ouvrir/fermer le menu',
            sortBy: 'Trier par',
            results: 'résultats',
            filter: 'Filtrer',
            filterBy: 'Filtrer par',
            removeFilters: 'Effacer les filtres',
            hideFilters: 'Replier tous les filtres',
            showFilters: 'Déplier tous les filtres',
            filters: 'de filtres',
            logout: 'Se déconnecter',
            yes: 'Oui',
            no: 'Non',
            allF: 'Toutes',
            all: 'Tous',
            send: 'Envoyer',
            validate: 'Valider',
            docFormat: 'Format de fichier attendu : .pdf, .png, .jpg',
            dragdrop: 'ou glisser-déposer le ici',
            updated: 'mis à jour le',
            wait: 'Veuillez patienter',
            saved: 'Enregistrement effectué',
            login: 'Se connecter',
            hasErrors: 'Le formulaire contient des erreurs ou est incomplet.',
            required: 'Le champs est requis.',
            badAge: 'Le participant n\'aura pas l\'âge requis au moment du stage.',
            areRequired: '(*) Ces champs sont requis',
            optional: 'facultatif',
            requiredConditions: 'Vous devez accepter les conditions.',
            idMember: "N° d'adhérent",
            unmatchingFields: 'Le champs ne correspond pas.',
            invalidEmail: "L'adresse e-mail est invalide.",
            email: 'E-mail',
            emailConfirmation: 'Confirmation e-mail',
            passwordLimitation: '6 caractères minium',
            newPassword: 'Nouveau mot de passe',
            newPasswordConfirmationTitle: 'Changement de mot de passe',
            newPasswordConfirmationText: 'Votre nouveau mot de passe a bien été enregistré. Veuillez maintenant vous reconnecter.',
            password: 'Mot de passe',
            passwordConfirmation: 'Confirmation du mot de passe',
            oldPassword: 'Ancien mot de passe',
            newPasswordConfirmation: 'Confirmation du nouveau mot de passe',
            civility: 'Civilité',
            male: 'Monsieur',
            female: 'Madame',
            lastname: 'Nom',
            firstname: 'Prénom',
            address: 'Adresse',
            searchAddress: 'Trouver mon adresse...',
            postalCode: 'Code postal',
            city: 'Ville',
            country: 'Pays',
            birthdate: 'Date de naissance',
            nationality: 'Nationalité',
            mobilephone: 'Téléphone portable',
            phone: 'Téléphone fixe',
            checkLicense: 'Vérifier ma licence',
            saveModifications: 'Enregistrer les modifications',
            save: 'Enregistrer',
            cancel: 'Annuler',
            termsOfUseApproval: 'J’ai lu et j’accepte les conditions générales d’utilisation',
            termsOfSellApproval: "J’ai lu et j’accepte les <a href=\"https://dossier-presse.glenans.asso.fr/docs/catalogues/CGV.pdf\" target='_blank'>conditions générales de vente</a>",
            cardName: 'Nom du propriétaire',
            cardNumber: 'Numéro de la carte',
            cardMonth: 'Mois',
            cardYear: 'Année',
            confirm: 'Confirmer',
            cardCode: 'Code de sécurité',
            reinit: 'Réinitialiser',
            selectAccount: 'Il y\'a plusieurs comptes liés à cette adresse. Merci de sélectionner votre compte',
            previous: 'Précédent',
            next: 'Suivant'
        },
        account: {
            mySupervision: 'Mes encadrements',
            myRtq: 'Validation RTQ',
            myAssessments: 'Retour satisfaction',
            satisfaction: 'Satisfaction',
            gotoAdmin: 'Panneau d\'administration',
            hasBeenUpdated: 'Votre compte adhérent a bien été mis à jour.',
            emailEmpty: 'Vous devez saisir une adresse e-mail valide pour créer un compte adhérent',
            emailAlreadyExists: 'cette adresse e-mail est déjà enregistrée.',
            deliveryAddressChoice: 'Souhaitez-vous utiliser cette adresse pour la livraison',
            unknown: 'Utilisateur inconnu.',
            backSignIn: "Retour à l'écran de connexion",
            //signinMenu: 'Connexion',
            signinTitle: 'Identifiez-vous',
            modifyEmail: 'Modifier l\'email',
            alreadyAccountTitle: "J'ai déjà un compte !",
            alreadyAccountDescription: 'Si vous possédez déjà un compte Les Glénans, identifiez-vous avec votre adresse e-mail.',
            alreadyAccountButton: 'Me connecter',
            changePasswordTitle: 'Changement de mot de passe',
            forgotPasswordTitle: 'Récupération de mot de passe',
            forgotPasswordDescription: "Pour récupérer votre mot de passe, veuillez renseigner l'adresse e-mail rattachée à votre compte.",
            forgotPasswordLink: 'Mot de passe oublié',
            forgotPasswordResult: "Un email a été envoyé à l'adresse « {email} ».",
            newAccountTitle: 'Je suis nouveau !',
            newAccountDescription: "En créant un compte sur notre site, vous pourrez passer vos commandes plus rapidement, consulter et suivre vos commandes, et plein d'autres choses encore.",
            newAccountButton: 'Créer mon compte',
            legalGuardian: 'Tuteur légal',
            secondaryContact: 'Autre personne à contacter en cas de besoin',
            idMember: 'Adhérent n°',
            idMemberAsk: 'Vous avez un n° adhérent',
            idMemberInfo: "J'ai un ancien numéro",
            idMemberFormat: 'numéro à 7 chiffres',
            idMemberButton: "Chercher ce numéro d'adhérent",
            internshipsMonitor: 'Stages à encadrer',
            title: 'Espace adhérent',
            welcome: 'Bonjour {name},',
            myHome: 'Mon accueil',
            myAccount: 'Mon espace personnel',
            myAccountInfo: 'Mes infos perso',
            myOrders: 'Mes commandes',
            myMembership: 'Ma cotisation',
            myTrainings: 'Mes formations',
            myProgress: 'Ma progression',
            myTrainingsDocuments: 'Mon CV nautique',
            trainingsDocuments: 'CV Nautique',
            trainingsDocumentsDate: 'En date du {date}',
            myTrainingsLegend: 'Mes stages aux Glénans',
            noTraining: 'Aucun stage enregistré',
            myOffTrainings: 'Mes stages hors Glénans',
            myOffTrainingsLegend: 'Informez nous de tous vos stages et activités réalisés en dehors des de l’association des Glénans.',
            myOffTrainingsLabel: 'Indiquez les informations suivantes : Stage / Activité / Niveau / Date du stage / Nom de l’organisme',
            myCoordinates: 'Mes coordonnées',
            myCoordinatesDelivery: 'Mes coordonnées & Livraison',
            myInfo: 'Mes informations',
            myInfoShort: 'Mes infos',
            myDocuments: 'Mes documents administratifs',
            myMedicalDocuments: 'Mes documents & informations médicales',
            myMedicalDocumentsDetail: 'Gardez à portée de mains tous vos documents nécessaires au bon déroulement de vos stages',
            myParameters: 'Mes paramètres de connexion',
            modifyParameters: 'Modifier mes identifiants',
            modifyParametersLegend: 'Modifier vos paramètres de connexion',
            modifyCoordinates: 'Modifier mes coordonnées',
            modifyCoordinatesLegend: 'Modifier vos coordonnées',
            noCoordinate: 'Aucune coordonnée enregistrée',
            handicapInform: 'Informez-nous de vos conditions médicales',
            checkMembership: 'Vérifier votre numéro de license auprès de la Fédération Française de Voile',
            membership: 'Mon n° de licence FFVoile',
            myMembershipCard: 'Ma carte adhérent',
            downloadMembershipCard: "Télécharger ma carte d'adhérent",
            mobilephone: 'Tél. portable',
            phone: 'Tél. fixe',
            born: 'Né(e) le',
            handicap: 'Handicap',
            documentDownload: 'Voir',
            documentAdd: 'Mettre à jour',
            documentMedicalCertificat: 'Certificat médical',
            documentMedicalCertificatAdd: 'Transmettre un document à jour',
            documentRecord: 'Fiche de liaison junior',
            documentRecordAdd: 'Transmettre un document à jour',
            documentRules: 'Fiche règles de fonctionnement',
            documentRulesAdd: 'Transmettre un document à jour',
            documentPermissionAuth: 'Autorisation de sortie du territoire',
            documentPermissionAuthAdd: 'Transmettre un document à jour',
            graduationTitle: 'Titres et diplômes obtenus',
            graduationType: 'Type',
            graduationGoal: 'Objet',
            graduationAttachments: 'PJ',
            graduationAttachmentsLong: 'Pièces jointes',
            graduationDate: 'Date',
            nograduation: 'Aucun titre ou diplôme à afficher',
            tokenError: 'Erreur : le lien a expiré ou a déjà été utilisé ! Pour recevoir un nouveau lien de réinitialisation, faire à nouveau votre demande ci-dessous.',
            changePasswordTitle: 'Réinitialiser votre mot de passe',
            referralCode: 'Code de parrainage',
            identyWithMermbershipNumber: "Identifiez-vous avec votre numéro d’adhérent"
        },
        orders: {
            noOrder: 'Aucune commande enregistrée pour votre compte',
            actionsModiciation: 'Démarches et modifications',
            documents: 'Documents',
            guarantees: 'Assurances & options',
            reference: 'Référence',
            date: 'Date',
            amount: 'Montant',
            paid: 'Réglée',
            pay: 'Solder',
            showDetails: 'Afficher le détail',
            hideDetails: 'Masquer le détail',
            show: 'Afficher',
            hide: 'Masquer',
            downloadBill: 'Voir la facture',
            payBill: 'Payer le solde',
            status: "Statut"
        },
        fees: {
            noOrder: 'Aucune cotisation demandée pour votre compte',
            title: 'Intitulé',
            amount: 'Montant',
            showDetails: 'Afficher le détail',
            hideDetails: 'Masquer le détail',
        },
        trainings: {
            myLevel: 'Mon niveau d’expérience',
            downloadProgression: 'Télécharger la carte de progression',
            skills: 'compétences',
            noskill: 'Aucune compétence à afficher',
            evaluations: 'évaluations',
            training: 'Fortmation',
            dates: 'Dates',
            age: 'Âge',
            level: 'Niveau',
            category: 'Catégorie',
            howToPrepare: 'Comment me préparer ?',
            downloadGuide: 'Télécharger le guide du stagiaire',
            acquiredNot: 'Non acquis',
            acquiredPending: 'En cours',
            acquiredDone: 'Acquis',
            supervisorValidation: 'Validation encadrant',
            supervisorValidationWarningLvl4: 'Ce niveau ne correspond pas au niveau d\'entrée en formation moniteur.trice.',
            globalSupervisorValidation: 'Validation FT ou FN/R',
            levelAquiredDone: 'Niveau validé',
            levelAquiredNot: 'Niveau non validé',
            functionLabel: 'En tant que',
            titlePreco: "Recommandation de votre encadrant.e suite à votre dernier stage",
            foilInfo: "Les compétences suivies de #Foil ne sont à remplir que sur les stages avec pratique du foil."
        },
        assessments: {
            annex: "Annexe",
            productsLocation: "Produits location",
            productsShop: "Produits boutique",
            internshipsToEvaluate: 'Stages à évaluer',
            internshipsToEvaluateInfo: 'Le Cursus Glénans Dématérialisé est complété après avoir été présenté au stagiaire et avec son accord explicite.',
            internshipsPending: 'Stages en cours',
            internshipIncoming: 'Stages à venir',
            empty: 'Aucune évaluation en cours',
            internship: 'Stage',
            date: 'Période',
            dateBegin: 'Date de début',
            dateBeginFrom: 'Depuis le',
            audience: 'Public',
            evaluation: 'Note',
            base: 'Base',
            seeMore: 'Voir le détail',
            noResponse: 'Pas de réponse',
            evaluate: 'Evaluer',
            evalidate: 'Evaluer / valider',
            validate: 'Valider',
            reception: 'Gérer l\'accueil',
            noInternship: 'Aucun stage à afficher',
            titleDetailIntern: 'Stagiaires',
            titleDetail: 'Détail',
            titleSatisfaction: 'Satisfaction',
            back: 'Retour',
            backInterns: 'Retour aux stagiaires',
            noAttendees: 'Aucun participant à afficher',
            checkAttendee: 'Vérification du dossier',
            payments: 'Réglements',
            internshipPayment: 'Solde du stage',
            bailPayment: 'Solde de la caution',
            documents: 'Documents',
            licenseValidity: 'Validité licence',
            medicalCertificatValidity: 'Certificat médical',
            recordJuniorValidity: 'Fiche de liaison',
            permissionAuthValidity: 'Autorisation de sortie du territoire',
            documentsMinorWarning: '(Pensez à vérifier la carte d\'identité du responsable légal)',
            documentsIDWarning: '(Pensez à vérifier la carte d\'identité du stagiaire)',
            paid: 'payé',
            toPay: '(reste à payer)',
            titleCompetencies: 'Evaluation des compétences',
            titleCompetenciesValidation: 'Evaluation des compétences',
            preconisation: 'Préconisation pour la suite',
            comments: 'Observations',
            commentsInfo: 'Si le champ est déjà rempli, vous pouvez compléter ou remplacer le texte.',
            commentsPlaceholder: 'Saisissez ici jusqu\'à 1000 caractères',
            activity: 'Filière',
            level: 'Niveau',
            chooseActivity: 'Choix filière',
            chooseLevel: 'Choix niveau',
            closeEvaluation: 'Evaluation terminée',
            confirmEvaluationTitle: 'Confirmez-vous l\'évaluation ?',
            confirmEvaluationSubtitle: 'cette opération sera définitive',
            notation: 'Note de satisfaction globale',
            noCompetency: 'Aucune compétence à afficher',
            noLevel: 'Aucun niveau à afficher',
            evaluationFinishOk: 'L\'évaluation a bien été enregistrée',
            noFeedback: 'Aucune Réponse à l’enquête pour ce stage.',
            acquiredDone: 'Acquis',
            functionLabel: 'En tant que'
        },
        supervision: {
            allCategories: 'Toutes',
            base: 'Base',
            contentDescriptionStart: 'Liste des postes ouverts à l’encadrement et libres au ',
            contentDescriptionEnd: ', sous réserve de la bonne adéquation stagiaires / encadrant.es et d\'éventuelles pré-réservation en cours de validation.',
            audience: 'Public',
            category: 'Filière',
            level: 'Niveau',
            levelShort: 'Niv.',
            internship: 'Stage',
            start: 'Début',
            end: 'Fin',
            duration: 'Jours',
            durationShort: 'Jrs',
            lang: 'Langue',
            noInternship: 'Aucun stage à afficher',
            chooseCategory: 'Choisir une filière',
            modifyCategory: 'Modifier les filières',
        },
        membership: {
            oneYear: 'Adhésion',
            alreadyAMember: 'Déjà adhérent pour {year}',
            alreadyAMemberDescription: 'La cotisation pour {nextYear} pourra être prise à partir du 1er janvier prochain depuis le site internet. Elle vous sera néanmoins proposée automatiquement dans votre panier pour toute commande d’un stage débutant en {nextYear}.'
        },
        modalTrad: {
            confirm: "Confirmer",
            changeLang: "Changement de langue"
        }
    }
});

/**
 * Urls constant
 */
module.constant('urls', {
    internship: {
        fr: 'stages',
        en: 'internship'
    },
    shop: {
        fr: 'boutique',
        en: 'shop',
        list: {
            fr: 'liste',
            en: 'list'
        },
        product: {
            fr: 'produit',
            en: 'product'
        }
    },
    cart: {
        fr: 'panier',
        en: 'cart'
    },
    catalog: {
        fr: 'catalogues',
        en: 'catalogs'
    },
    print: {
        fr: 'impression',
        en: 'print'
    },
    order: {
        fr: 'commande',
        en: 'order',
        confirmation: {
            fr: 'confirmation',
            en: 'confirmation'
        },
        participants: {
            fr: 'participants',
            en: 'participants'
        },
        payment: {
            fr: 'paiement',
            en: 'payment'
        }
    },
    user: {
        fr: 'utilisateur',
        en: 'user',
        login: {
            fr: 'identification',
            en: 'login'
        },
        forgot: {
            fr: 'mot-de-passe-oublie',
            en: 'forgot-password'
        },
        changepwd: {
            fr: 'changer-mot-de-passe',
            en: 'change-password'
        }
    },
    edit: {
        fr: 'edition',
        en: 'edit'
    },
    member: {
        fr: 'mon-espace',
        en: 'my-account',
        infos: {
            fr: 'mes-infos',
            en: 'my-data'
        },
        coordinates: {
            fr: 'mes-coordonnees',
            en: 'my-coordinates'
        },
        documents: {
            fr: 'mes-documents',
            en: 'my-documents'
        },
        training: {
            fr: 'mes-formations',
            en: 'my-trainings',
            graduation: {
                fr: 'mes-titres-et-diplomes',
                en: 'my-graduation'
            },
        },
        orders: {
            fr: 'mes-commandes',
            en: 'my-orders',
            list: {
                fr: 'liste',
                en: 'list'
            }
        },
        membership: {
            fr: 'mes-cotisations',
            en: 'my-fees',
            list: {
                fr: 'liste',
                en: 'list'
            }
        },
        internships: {
            fr: 'stages-a-encadrer',
            en: 'internships'
        },
        assessments: {
            fr: 'satisfaction',
            en: 'my-assessments',
            notation: {
                fr: 'notation',
                en: 'notation'
            }
        },
        supervision: {
            fr: 'mes-encadrements',
            en: 'my-supervision',
            reception: {
                fr: 'accueil-stagiaires',
                en: 'recepetion-interns'
            },
            evaluations: {
                fr: 'evaluations',
                en: 'evaluations'
            },
            evaluation: {
                fr: 'evaluation',
                en: 'evaluation'
            },
            validation: {
                fr: 'validation',
                en: 'validation'
            }
        },
        rtq: {
            fr: 'validation-rtq',
            en: 'rtq-validation',
            evaluations: {
                fr: 'evaluations',
                en: 'evaluations'
            },
            evaluation: {
                fr: 'evaluation',
                en: 'evaluation'
            },
            validation: {
                fr: 'validation',
                en: 'validation'
            }
        }
    },
    news: {
        fr: 'actualites',
        en: 'news'
    }
});

module.constant('formPattern', {
    phone: {
        check: /^\+?[\d]{8,}$/,
        errormessage: 'Entrez un numéro au format “0612345678” ou “+33612345678" (sans espace, point ou tiret)'
    }
});
module.constant('pattern', {
    noTranslatePattern: /english|italiano/i
});
